import React, { useState } from 'react';
import { Gift, Lock } from "@phosphor-icons/react";
import type { AvatarItem } from '../types/types';
import { usePaidItems } from '../hooks/usePaidItems';

interface ItemPaletteProps {
  availableItems: AvatarItem[];
  onItemSelect: (item: AvatarItem) => void;
  onPurchaseRequest?: (item: AvatarItem) => void; 
  onItemRemove?: (category: string) => void; 
  selectedCategory?: string; 
}

const COLOR_MAPPING = [
  { color: '#9b59b6', label: 'Morado', field: 'image' },         
  { color: '#e74c3c', label: 'Rojo', field: 'image_red' }, 
  { color: '#f1c40f', label: 'Amarillo', field: 'image_yellow' },
  { color: '#2ecc71', label: 'Verde', field: 'image_green' },
  { color: '#3498db', label: 'Azul 1', field: 'image_blue1' },
  { color: '#2980b9', label: 'Azul 2', field: 'image_blue2' },
  { color: '#8B4513', label: 'Marrón', field: 'image_brown' }
];

const HAIR_COLOR_MAPPING = [
  { color: '#2c3e50', label: 'Azul Oscuro', field: 'image' },     
  { color: '#e74c3c', label: 'Rojo', field: 'image_red' },    
  { color: '#f1c40f', label: 'Amarillo', field: 'image_yellow' },  
  { color: '#2ecc71', label: 'Verde', field: 'image_green' },     
  { color: '#e91e63', label: 'Rosa', field: 'image_blue1' },      
  { color: '#95a5a6', label: 'Gris', field: 'image_blue2' },     
  { color: '#8B4513', label: 'Marrón', field: 'image_brown' }     
];

const hasColorVariants = (item: AvatarItem): boolean => {
  const colorFields = ['image_red', 'image_yellow', 'image_green', 'image_blue1', 'image_blue2', 'image_brown'];
  
  return colorFields.some(field => {
    const value = item[field as keyof AvatarItem];
    return value && typeof value === 'string' && value.length > 0;
  });
};

const REMOVABLE_CATEGORIES = ['hair', 'shoes', 'hand_props', 'head_props', 'body_props', 'pets'];

const ItemPalette: React.FC<ItemPaletteProps> = ({ 
  availableItems, 
  onItemSelect, 
  onPurchaseRequest, 
  onItemRemove, 
  selectedCategory 
}) => {
  const [selectedItem, setSelectedItem] = useState<AvatarItem | null>(null);
  const { isItemEnabled } = usePaidItems();
  
  
  const sortedItems = React.useMemo(() => {
    return [...availableItems].sort((itemA, itemB) => {
      const itemAEnabled = isItemEnabled(itemA);
      const itemBEnabled = isItemEnabled(itemB);
      
      
      if (itemAEnabled && !itemBEnabled) return -1;
      
      if (!itemAEnabled && itemBEnabled) return 1;
      
      return 0;
    });
  }, [availableItems, isItemEnabled]);
  
      if (availableItems.length === 0) {
    return (
      <div className="hair-options">
        <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>
          <p>Ningún artículo encontrado en esta categoría</p>
        </div>
      </div>
    );
  }

  
  const isSkinCategory = sortedItems[0]?.category === 'skin';
  
  if (isSkinCategory) {
    return (
      <div className="skin-colors">
        {sortedItems.map((item) => {
          return (
            <button
              key={item.id}
              className="skin-color"
              onClick={() => onItemSelect(item)}
              title={item.title || `Tono de piel`}
              style={{
                backgroundColor: item.skinColor || '#f5deb3',
                border: '3px solid #e5e7eb',
                borderRadius: '50%',
                width: '100%',
                height: '100%',
                maxWidth: '48px',
                maxHeight: '48px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                margin: '0'
              }}
            >
              {}
            </button>
          );
        })}
      </div>
    );
  }

  
  const canRemoveItems = selectedCategory && REMOVABLE_CATEGORIES.includes(selectedCategory);

  return (
    <>
      <div className="hair-options">
        {}
        {canRemoveItems && onItemRemove && (
          <div style={{ position: 'relative', margin: '5px' }}>
            <button
              className="hair-option"
              onClick={() => {
                onItemRemove(selectedCategory);
              }}
              title={`Eliminar ${selectedCategory}`}
              style={{
                border: '2px solid #e5e7eb',
                borderRadius: '50%',
                width: '100%',
                height: '100%',
                maxWidth: '48px',
                maxHeight: '48px',
                overflow: 'hidden',
                padding: '3px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px'
              }}
            >
              🚫
            </button>
          </div>
        )}
        
        {sortedItems.map((item) => {
          
          const displayImage = item.catalogImage || item.src;
          const hasVariants = hasColorVariants(item);
          
                    return (
            <div key={item.id} style={{ position: 'relative', margin: '5px' }}>
              <button
                className="hair-option"
                onClick={() => {
                                    
                  const itemEnabled = isItemEnabled(item);
                                    if (!itemEnabled) {
                    
                    if (onPurchaseRequest) {
                      onPurchaseRequest(item);
                    }
                    return;
                  }
                  
                  
                                    if (hasVariants) {
                    const availableVariants = ['image_red', 'image_yellow', 'image_green', 'image_blue1', 'image_blue2', 'image_brown']
                      .filter(field => item[field as keyof AvatarItem] && typeof item[field as keyof AvatarItem] === 'string')
                      .join(', ');
                                      }
                  
                  setSelectedItem(item);
                  onItemSelect(item);
                }}
                title={item.title || `Agregar ${item.category}`}
                style={{
                  border: '2px solid #e5e7eb',
                  borderRadius: '50%',
                  width: '100%',
                  height: '100%',
                  maxWidth: '48px',
                  maxHeight: '48px',
                  overflow: 'hidden',
                  padding: '3px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: '#fff',
                  opacity: isItemEnabled(item) ? 1 : 0.6, 
                  filter: isItemEnabled(item) ? 'none' : 'grayscale(50%)', 
                }}
              >
                <img 
                  src={displayImage}
                  alt={item.title || item.category}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => {
                                        (e.target as HTMLImageElement).src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjZjBmMGYwIi8+Cjx0ZXh0IHg9IjMwIiB5PSIzNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1zaXplPSIyNCIgZmlsbD0iIzk5OSI+Pz88L3RleHQ+Cjwvc3ZnPgo=';
                  }}
                />
              </button>
              
              {}
              {!isItemEnabled(item) && (
                <div
                  style={{
                    position: 'absolute',
                    top: '2px',
                    right: '2px',
                    width: '20px',
                    height: '20px',
                    backgroundColor: '#ef4444',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    border: '1px solid white'
                  }}
                >
                  <Lock size={12} color="white" />
                </div>
              )}
              
              {}
              {hasVariants && isItemEnabled(item) && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '2px',
                    right: '2px',
                    width: '18px',
                    height: '18px',
                    backgroundColor: '#9b59b6',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    border: '1px solid white',
                    fontSize: '10px'
                  }}
                >
                  🎨
                </div>
              )}
            </div>
          );
        })}
      </div>

      {}
      {selectedItem && hasColorVariants(selectedItem) && isItemEnabled(selectedItem) && (
        <div style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          margin: '20px 0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ margin: '0 0 15px 0', fontSize: '18px', color: '#333' }}>Colores</h3>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {}
            {(selectedItem.category === 'hair' ? HAIR_COLOR_MAPPING : COLOR_MAPPING).map(({ color, label, field }) => {
              
              const originalItem = sortedItems.find(i => i.id === selectedItem.id);
              
              if (!originalItem) {
                                return null;
              }

              return (
                <button
                  key={color}
                  onClick={() => {
                    let imageUrl: string;
                    
                    if (field === 'image') {
                      imageUrl = originalItem.src;
                    } else {
                      const colorVariantUrl = originalItem[field as keyof typeof originalItem] as string;
                      imageUrl = colorVariantUrl || originalItem.src; 
                    }
                    
                    const updatedItem: AvatarItem = {
                      ...originalItem,
                      src: imageUrl,
                      x: originalItem.x || 200,
                      y: originalItem.y || 250,
                      zIndex: originalItem.zIndex,
                      scale: originalItem.scale || 1,
                      rotation: originalItem.rotation || 0,
                      color: originalItem.color
                    };
                    
                    onItemSelect(updatedItem);
                    setSelectedItem(updatedItem);
                  }}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    border: '2px solid white',
                    background: color,
                    cursor: 'pointer',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}
                  title={label}
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ItemPalette;
